// extracted by mini-css-extract-plugin
export default {"table":"BranchList_table__xraqM","tdAction":"BranchList_tdAction__aVmsf","icon":"BranchList_icon__j5yoG","iconDelete":"BranchList_iconDelete__7MT0A"};